const initialState = {
  isLoading: false,
  refsdata: {},

  errors: null,
};

const Refreducer = (state = initialState, action) => {
  switch (action.type) {
    case "refList_req":
      return {
        ...state,
        isLoading: true,
      };
    case "refList_success":
      return {
        ...state,
        isLoading: false,

        refsdata: action.payload,
      };
    case "refList_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };

    default:
      return state;
  }
};


export { Refreducer };
